import { z } from 'zod'

import { SynopticSchema } from '@shared/schema/synoptic.base.schema'
import { numberOrStringToNumberSchema } from '@shared/schema/utils'

export const GetSynopticByIdPathParameterSchema = z.object({
  id: numberOrStringToNumberSchema,
})

export const GetSynopticByIdResponseSchema = SynopticSchema

export type GetSynopticByIdPathParameter = z.infer<typeof GetSynopticByIdPathParameterSchema>
export type GetSynopticByIdResponse = z.infer<typeof GetSynopticByIdResponseSchema>
